import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import css from '../styles/about.css';
import AOS from 'aos';

const { Component } = React;

class About extends Component {
  componentDidMount() {
    AOS.refreshHard();
    let body = $('body');
    let hasClass = body.hasClass('light-page');
    if (!hasClass) {
      body.addClass('light-page');
    }
  }

  componentWillUnmount() {
    let body = $('body');
    body.removeClass('light-page');
  }

  render() {
    let { lines } = this.props;

    return (
      <div className="about">
        <div className="about-hero"></div>
        <div className="about-hero__content" data-aos="zoom-in">
          {lines.map((line, i) => <p key={i}>{line}</p>)}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lines: state.about
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const AboutContainer = connect(mapStateToProps, mapDispatchToProps)(About);

export {About, AboutContainer};



// WEBPACK FOOTER //
// ./app/screens/App/screens/About/components/about.js